import { Show, createMemo, createSignal, onMount } from "solid-js";

import { Button } from "@/components/Base/Button/Button";
import { t } from "@/i18n";
import { isMobile } from "@/lib/isMobile";

export default function Cookies() {
  const [cookiesAccepted, setCookiesAccepted] = createSignal(true);

  onMount(() => {
    if (typeof window !== "undefined") {
      setCookiesAccepted(!!localStorage.getItem("cookies"));
    }
  });

  const handleCookie = () => {
    if (typeof window !== "undefined") {
      localStorage.setItem("cookies", "true");
      setCookiesAccepted(true);
    }
  };

  return (
    <Show when={!cookiesAccepted()} fallback={<></>}>
      <div class="fixed bottom-[90px] z-[500] mx-[12px] flex h-[114px] w-[calc(100%-24px)] flex-col justify-center rounded-[8px] bg-[#202221]">
        <div class="flex items-center">
          <div class="mr-[8px]">
            <img
              src={"/icons/mdi_biscuit.svg"}
              class="ml-[15px] h-[40px] w-[40px]"
            />
          </div>
          <div
            class="text-general-darkzi mr-[0px] text-[12px] font-[500]"
            onClick={() => {
              window.open(
                "https://img.engames.com/afunbet/COOKIE_BR.pdf?uid=0&ch=3&gno=0&ic=",
                "_blank",
              );
            }}
            innerHTML={`${t("home.cookie_notice", {
              val: `<span class="text-general-main underline hover:cursor-pointer">Cookies</span>`,
            })}`}
          ></div>
        </div>
        <div class="mt-[12px] w-[calc(100%-30px)]">
          <Button
            variant="primary"
            type="button"
            class="bg-linear-to-l from-up-mainbut-r to-up-mainbut-l text-up-butzi clickable mx-[15px] inline-block h-[40px] w-[100%] rounded-[6px] text-[14px] font-[800]"
            onClick={() => handleCookie()}
          >
            {t("home.accept")}
          </Button>
        </div>
      </div>
    </Show>
  );
}
